import { compose } from "redux";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { formatDate } from "utils/format.util";
import { WORK_SCHEDULE_STATUS } from "features/planner/planner.constants";
import CalendarWeekNumber from "app/components/CalendarYear/CalendarWeekNumber";
import WorkScheduleReportItem from "features/planner/report/workSchedule/components/WorkScheduleReportItem";
import WorkScheduleReportWorkDayWeek from "features/planner/report/workSchedule/components/WorkScheduleReportWorkDayWeek";

class WorkScheduleYearReportWorkWeekPreviewDay extends PureComponent {
  render() {
    const { date, classes, workDay } = this.props;

    const status = workDay ? workDay.get("status") : null;

    return workDay ? (
      <WorkScheduleReportWorkDayWeek
        status={status}
        flexDayCount={status === WORK_SCHEDULE_STATUS.OFF_FLEX ? 1 : 0}
        classes={{
          root: classNames(classes.root),
        }}
      >
        {workDay && (
          <Grid
            item
            container
            variant="caption"
            alignItems="center"
            justifyContent="center"
            direction="column"
            className={classNames(classes.dateContainer, {
              [classes.dateContainerToday]: date.isSame(undefined, "day"),
            })}
          >
            <Typography variant="caption" className={classes.dateDay}>
              {date.date()}
            </Typography>
            <Typography variant="caption" className={classes.dateDayName}>
              {formatDate(date, "ddd").toUpperCase()}
            </Typography>
          </Grid>
        )}
        <CalendarWeekNumber date={date} color="primary" />
      </WorkScheduleReportWorkDayWeek>
    ) : (
      <WorkScheduleReportItem
        classes={{
          root: classNames(classes.root, classes.noWorkDay),
        }}
      >
        <CalendarWeekNumber date={date} color="primary" />
      </WorkScheduleReportItem>
    );
  }
}

const styles = theme => ({
  root: {
    position: "relative",
    width: theme.altus.workScheduleReport.cellSize,
    height: theme.altus.workScheduleReport.cellSize,
    borderTop: theme.altus.workScheduleReport.defaultBorder,
    borderBottom: theme.altus.workScheduleReport.defaultBorder,
    "&:last-of-type": {
      borderRight: theme.altus.workScheduleReport.defaultBorder,
    },
  },
  noWorkDay: {
    borderLeft: 0,
    background: theme.palette.grey[50],
    "&:first-of-type": {
      borderLeft: theme.altus.workScheduleReport.defaultBorder,
    },
    "&:last-of-type": {
      borderRight: theme.altus.workScheduleReport.defaultBorder,
    },
  },
  dateContainer: {
    left: "50%",
    position: "absolute",
    bottom: theme.spacing(0.25),
    transform: "translateX(-50%)",
    zIndex: theme.zIndex.calendarDay,
    color: theme.palette.text.secondary,
    width: theme.altus.workScheduleReport.cellSize - theme.spacing(1),
    height: theme.altus.workScheduleReport.cellSize - theme.spacing(1),
  },
  dateContainerToday: {
    borderRadius: "50%",
    background: theme.altus.calendar.contrastColor,
    "& $dateDayName": {
      color: theme.palette.primary.contrastText,
    },
    "& $dateDay": {
      color: theme.palette.primary.contrastText,
    },
  },
  dateDay: {
    fontSize: "0.75rem",
    lineHeight: "0.75rem",
    fontWeight: theme.typography.fontWeightBold,
  },
  dateDayName: {
    fontSize: "0.5rem",
  },
});

export default compose(withStyles(styles))(
  WorkScheduleYearReportWorkWeekPreviewDay,
);
